module.exports = __webpack_public_path__ + "img/logo-sportssouth.c4e16a87.jpg";